import React, { memo, useEffect, useState } from 'react'
import Modal from 'react-modal'
import '../../styles/TermsAndConditions.css'
import '../../styles/TutorialModal.css'
import { useTranslation } from 'react-i18next'
import { ReactComponent as Checkbox } from '../../assets/svg/checkbox/Checkbox.svg'
import { ReactComponent as CheckboxEmpty } from '../../assets/svg/checkbox/CheckboxEmpty.svg'
import { ReactComponent as HappyHandsLogo } from '../../assets/svg/HappyHandsLogo.svg'

import { agreeToTermsAndPolicy } from '../../server/server'
import TermsAndConditionsContentModal from './TermsAndConditionsContentModal'
import ConfirmationModal from './ConfirmationModal'
import { useUser } from '../../auth'
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min'

const TermsAndConditionsModal = memo(({ modalIsOpen, afterOpenModal, closeModal, onDisagree }) => {
    const { t, locale } = useTranslation()
    let history = useHistory()
    const [agree, setAgree] = useState(false)
    const [isTCVisible, setTCVisible] = useState(false)
    const [isConfirmVisible, setConfirmVisible] = useState(false)
    const { setUser, user } = useUser()

    useEffect(() => {
        Modal.setAppElement('#root')
        if (modalIsOpen) {
            setTimeout(() => {
                document.getElementById('home').style.filter = 'blur(5px)'
            }, 100)
        } else {
            document.getElementById('home').style.filter = 'unset'
        }
    }, [modalIsOpen])

    const closeTCModal = () => setTCVisible(false)
    const openTCModal = () => setTCVisible(true)

    const submit = async () => {
        const resp = await agreeToTermsAndPolicy(user)
        if (resp.status === 200) {
            console.log(resp)

            setUser(resp.data)
            closeModal()
        }
    }

    const logout = () => {
        setUser({})
        localStorage.clear()
        setTimeout(() => {
            history?.push('/')
        }, 200)
    }

    const closeConfirmModal = () => setConfirmVisible(false)
    const openConfirmModal = () => {
        logout()
        closeModal()
    }

    const onPressDisagree = () => {
        closeConfirmModal()
        onDisagree()
    }

    return (
        <Modal
            isOpen={modalIsOpen}
            onAfterOpen={afterOpenModal}
            contentLabel="Terms and Conditions"
            onAfterClose={() => {
                setAgree(false)
            }}
            style={{
                overlay: {
                    zIndex: 10,
                },
                content: {
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    backgroundColor: 'transparent',
                    padding: 0,
                    border: 'none',
                    boxShadow: 'none',
                    overflow: 'hidden',
                    position: 'absolute',
                },
            }}
        >
            <div className="terms-and-conditions-modal">
                <div className="tutorial-right-side ">
                    <p className="tutorial-modal-title">{t('Terms and Conditions')} </p>

                    <div
                        style={{
                            flex: 1,
                            display: 'flex',
                            flexDirection: 'row',
                            alignItems: 'center',
                            justifyContent: 'center',
                            paddingTop: 50,
                        }}
                    >
                        <HappyHandsLogo />
                    </div>
                    <div style={{ display: 'flex', flexDirection: 'row', gap: 10, alignItems: 'center', marginBottom: 40 }}>
                        <button style={{ display: 'flex', alignItems: 'center', cursor: 'pointer', backgroundColor: 'transparent' }} onClick={() => setAgree(!agree)}>
                            {agree ? <Checkbox /> : <CheckboxEmpty />}
                        </button>
                        <div style={{ color: '#5E639B', flexWrap: 'wrap' }}>
                            {t("I confirm that I read and agree to Upstrive's")}{' '}
                            <b style={{ cursor: 'pointer' }} onClick={openTCModal}>
                                {t('Terms and Conditions')}
                            </b>
                        </div>
                    </div>
                    <div className="tutorial-footer">
                        <button onClick={openConfirmModal} className={`tutorial-previous-button`}>
                            {t('I do not agree')}
                        </button>
                        <button onClick={submit} className={`tutorial-next-button`} disabled={!agree}>
                            {t('Continue')}
                        </button>
                    </div>
                </div>
            </div>
            <TermsAndConditionsContentModal modalIsOpen={isTCVisible} closeModal={closeTCModal} />
            <ConfirmationModal
                modalIsOpen={isConfirmVisible}
                closeModal={closeConfirmModal}
                message={t('You will be logged out')}
                subMessage={t("If you don't agree to Terms and Conditions you are not going to be allowed to use the app!")}
                confirmation={onPressDisagree}
                okButtonText="Do not agree"
                showDeleteIcon={false}
            />
        </Modal>
    )
})

export default TermsAndConditionsModal
